import { useMutation } from '@tanstack/react-query'
import { ExtendableMutationOptions } from 'shared/api/api.types'

import { containerApi } from '../..'
import {
  SetActiveWallpaperRequest,
  SetActiveWallpaperResponse
} from './setActiveWallpaper.types'

export const setActiveWallpaper = async (
  request: SetActiveWallpaperRequest
) => {
  const response = await containerApi.post<SetActiveWallpaperResponse>(
    '/desktop/wallpaper/active',
    request
  )
  return response.data
}

export const useSetActiveWallpaperMutation = (
  options?: ExtendableMutationOptions<
    SetActiveWallpaperResponse,
    SetActiveWallpaperRequest
  >
) => {
  return useMutation({
    mutationFn: setActiveWallpaper,
    ...options
  })
}
